import axios from "axios";

const skillApi = axios.create({
  baseURL: process.env.REACT_APP_SKILL_PATH,
});

skillApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) config.headers["x-access-token"] = token;
    return config;
  },
  (err) => Promise.reject(err)
);

skillApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const accessToken = localStorage.getItem("accessToken");
      const refreshToken = localStorage.getItem("refreshToken");

      if (!accessToken || !refreshToken) return Promise.reject(error);

      const res = await skillApi.post("/auth/refresh", {}, {
        headers: {
          "x-access-token": accessToken,
          "x-refresh-token": refreshToken,
        },
      });

      if (res.status === 200) {
        localStorage.setItem("accessToken", res.data.accessToken);
        localStorage.setItem("refreshToken", res.data.refreshToken);
        return skillApi(originalRequest);
      }
    }

    return Promise.reject(error);
  }
);

export default skillApi;
